import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash, faSave, faCheck, faDesktop } from '@fortawesome/free-solid-svg-icons';

/**
 * BoxABM - Premium CRUD for Service Boxes (Puestos de atención)
 */
const BoxABM = ({ ipserv, hideHeader = false, branch_id }) => {
    const [loading, setLoading] = useState(false);
    const [boxes, setBoxes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        BoxNombre: '',
        BoxDescripcion: ''
    });

    const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

    const loadBoxes = () => {
        if (!branch_id) return;
        setLoading(true);
        request.Get(API_BASE + 'getTurneroBoxes', { sucursalId: branch_id }, r => {
            if (r.success) {
                setBoxes(r.data || []);
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        loadBoxes();
    }, [branch_id]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setFormData(item || {
            BoxNombre: '',
            BoxDescripcion: ''
        });
        setShowModal(true);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(API_BASE + 'saveTurneroBox', { ...formData, BoxId: currentItem?.BoxId, SucursalId: branch_id }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Box guardado correctamente' });
                setShowModal(false);
                loadBoxes();
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al guardar' });
            }
            setLoading(false);
        });
    };

    const handleDelete = (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este Box?')) {
            request.Post(API_BASE + 'deleteTurneroBox', { BoxId: id }, r => {
                if (r.success) {
                    Notify({ type: 'success', text: 'Box eliminado' });
                    loadBoxes();
                } else {
                    Notify({ type: 'fail', text: 'Error al eliminar' });
                }
            });
        }
    };

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Gestión de Boxes</h2>
                    <p className="text-muted small">Configura los puestos de atención física para esta sucursal.</p>
                </div>
                <button
                    className="auth-btn-primary"
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
                    onClick={() => handleOpenModal()}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nuevo Box
                </button>
            </div>

            <div className="premium-table-container">
                <table className="premium-table">
                    <thead>
                        <tr>
                            <th>Nombre del Box</th>
                            <th>Descripción</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <AnimatePresence mode='popLayout'>
                            {loading && boxes.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center p-5">
                                        <Spinner animation="border" variant="primary" />
                                    </td>
                                </tr>
                            ) : boxes.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center p-5 text-muted">No hay boxes configurados para esta sucursal.</td>
                                </tr>
                            ) : (
                                boxes.map((b, idx) => (
                                    <motion.tr
                                        key={b.BoxId || idx}
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, scale: 0.95 }}
                                        transition={{ delay: idx * 0.05 }}
                                    >
                                        <td className="font-weight-bold" style={{ color: '#fff' }}>
                                            <FontAwesomeIcon icon={faDesktop} className="mr-2 opacity-50" />
                                            {b.BoxNombre}
                                        </td>
                                        <td className="text-muted">{b.BoxDescripcion || 'Sin descripción'}</td>
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center gap-2">
                                                <button className="btn btn-link text-info p-0" onClick={() => handleOpenModal(b)}>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button className="btn btn-link text-danger p-0" onClick={() => handleDelete(b.BoxId)}>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </motion.tr>
                                ))
                            )}
                        </AnimatePresence>
                    </tbody>
                </table>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                className="premium-modal"
            >
                <form onSubmit={handleSave}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FontAwesomeIcon icon={faDesktop} className="mr-2 text-primary" />
                            {currentItem ? 'Editar Box' : 'Nuevo Box'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="auth-input-group">
                            <input
                                type="text"
                                className="auth-input"
                                value={formData.BoxNombre}
                                onChange={e => setFormData({ ...formData, BoxNombre: e.target.value.toUpperCase() })}
                                required
                                placeholder="Nombre (Ej: BOX 1, CAJA 4, MESA ENTRADA)"
                            />
                            <FontAwesomeIcon icon={faDesktop} className="auth-input-icon" />
                        </div>

                        <div className="auth-input-group">
                            <textarea
                                className="auth-input"
                                rows="3"
                                value={formData.BoxDescripcion}
                                onChange={e => setFormData({ ...formData, BoxDescripcion: e.target.value })}
                                placeholder="Descripción opcional..."
                                style={{ padding: '1rem' }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-link text-muted text-decoration-none" onClick={() => setShowModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="auth-btn-primary" style={{ width: 'auto', padding: '0.75rem 2rem' }} disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : (
                                <><FontAwesomeIcon icon={currentItem ? faSave : faCheck} /> {currentItem ? 'Actualizar' : 'Crear Box'}</>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};

export default BoxABM;
